<p>{{ 'instType_intro' | translate }}</p>

<!-- new/existing installation -->
<ion-grid class="products ion-no-margin ion-margin-vertical ion-no-padding">
  <ion-row class="ion-no-padding">
    <ion-col
      (click)="onNewSelected()"
      class="product"
      [ngClass]="{ active: isNewSelected() }"
      size-xs="12"
      size-sm="12"
      size-md="12"
    >
      <div class="ion-margin ion-padding">
        <h2>{{ 'instType_new' | translate }}</h2>
        <p [innerHTML]="'instType_newIntro' | translate"></p>
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="ion-no-padding">
    <ion-col
      (click)="onExistingSelected()"
      class="product"
      [ngClass]="{ active: isExistingSelected() }"
      size-xs="12"
      size-sm="12"
      size-md="12"
    >
      <div class="ion-margin ion-padding">
        <h2>{{ 'instType_existing' | translate }}</h2>
        <p [innerHTML]="'instType_existingIntro' | translate"></p>
        @if (isExistingSelected()) {
          <p
            [innerHTML]="'instType_existingIntroExtra' | translate"
            class="extra"
          ></p>
          <h3>{{ installerCode() }}</h3>
        }
      </div>
    </ion-col>
  </ion-row>
</ion-grid>

<!-- button to submit selection -->
<ion-button
  [disabled]="!isNewSelected()"
  type="submit"
  class="ion-float-right"
  color="primary"
  (click)="submitType()"
>
  <small>{{ btnText() | translate }}</small>
</ion-button>
